/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-useless-catch */
import { API } from "../api";
import {
  EMPLOYEES_URL,
  EMPLOYEE_RESET_PASSWORD
} from "../constants/url.constant";

export const GET_EMPLOYEES = "GET_EMPLOYEES";
export const GET_EMPLOYEE = "GET_EMPLOYEE";
export const ADD_EMPLOYEES = "ADD_EMPLOYEES";
export const DELETE_EMPLOYEE = "DELETE_EMPLOYEE";
export const UPDATE_EMPLOYEE = "UPDATE_EMPLOYEE";

export const getEmployees = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(EMPLOYEES_URL, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_EMPLOYEES,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getEmployeeById = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${EMPLOYEES_URL}/${id}`);
      dispatch({
        type: GET_EMPLOYEE,
        payload: res
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addEmployee = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(EMPLOYEES_URL, data);
      dispatch({
        type: ADD_EMPLOYEES,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateEmployee = (id, body) => {
  return async (dispatch) => {
    try {
      await API.put(`${EMPLOYEES_URL}/${id}`, body);
      dispatch({ type: UPDATE_EMPLOYEE, payload: { id, ...body } });
    } catch (error) {
      throw error;
    }
  };
};

export const removeEmployee = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${EMPLOYEES_URL}/${id}`);
      dispatch({
        type: DELETE_EMPLOYEE,
        payload: id
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const resetEmpPass = (id, body) => {
  return async (dispatch) => {
    try {
      const res = await API.put(
        EMPLOYEE_RESET_PASSWORD.replace("empId", id),
        body
      );
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = { employeeTableRows: [], totalRows: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_EMPLOYEES:
      return {
        ...state,
        employeeTableColumns: payload.columns,
        employeeTableRows: payload.rows,
        totalRows: payload.count
      };
    case GET_EMPLOYEE:
      return {
        ...state,
        employeeDetails: payload
      };
    case ADD_EMPLOYEES:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        employeeTableRows: [...state.employeeTableRows, { ...payload }]
      };
    case DELETE_EMPLOYEE:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        employeeTableRows: state.employeeTableRows.filter(
          (employee) => employee.id !== payload
        )
      };
    case UPDATE_EMPLOYEE:
      return {
        ...state,
        employeeTableRows: state.employeeTableRows.map((employee) =>
          employee.id === payload.id ? { ...employee, ...payload } : employee
        )
      };
    default:
      return state;
  }
}
